/* eslint-disable quotes */

/**
 * Normaliza un string: quita acentos, pasa a minúsculas, trim.
 */
export function normalizeText(s = "") {
  return (s || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[.,;:!?]/g, " ")
    .trim()
    .toLowerCase();
}

/**
 * Busca coincidencias de palabras prohibidas dentro de un texto.
 * @param {string} text - Texto a validar.
 * @param {Array<{id:number, name:string}>} forbiddenTerms - Lista de palabras prohibidas.
 * @returns {string[]} - Lista de coincidencias.
 */
export function checkForbiddenSimple(text, forbiddenTerms = []) {
  if (!text) return [];
  const normalizedText = normalizeText(text);
  const hits = new Set();

  for (const name of forbiddenTerms) {
    const normName = normalizeText(String(name || "").trim());
    if (!normName) continue;

    // Palabra sola vs frase
    if (!/\s/.test(normName)) {
      const re = new RegExp(`(?<![\\p{L}\\p{N}_])${normName}(?![\\p{L}\\p{N}_])`, "iu");

      if (re.test(normalizedText)) hits.add(name);
    } else {
      if (normalizedText.includes(normName)) hits.add(name);
    }
  }

  return Array.from(hits);
}

/**
 * Valida un campo específico y guarda en el objeto forbidden.
 * @param {object} forbidden - Estado actual de forbidden.
 * @param {string} fieldKey - Clave del campo a validar (ej: "subtitle").
 * @param {string} value - Texto a validar.
 * @param {Array} forbiddenTerms - Lista de palabras prohibidas.
 * @returns {object} - Objeto forbidden actualizado.
 */
export function checkForbidden(forbidden, fieldKey, value, forbiddenTerms) {
  if (!forbidden) forbidden = {};
  const hits = checkForbiddenSimple(value, forbiddenTerms);
  return { ...forbidden, [fieldKey]: hits };
}

/**
 * Devuelve true si un campo contiene palabras prohibidas.
 */
export function hasForbidden(forbidden, fieldKey) {
  return (forbidden?.[fieldKey] || []).length > 0;
}

/**
 * Devuelve la lista de palabras prohibidas encontradas en un campo.
 */
export function getForbidden(forbidden, fieldKey) {
  return forbidden?.[fieldKey] || [];
}
